function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import classNames from 'classnames';
import React, { Children, memo, useMemo } from 'react';
import "./index.less";
// space px
var spaceSizeList = {
  mini: 4,
  small: 8,
  medium: 16,
  large: 24
};
var defaultAlignItems = {
  start: {
    alignItems: 'flex-start'
  },
  center: {
    alignItems: 'center'
  },
  end: {
    alignItems: 'flex-end'
  },
  baseline: {
    alignItems: 'baseline'
  }
};
var sizeAgent = new Proxy(spaceSizeList, {
  get: function get(target, prop) {
    var _target$prop;
    return typeof prop === 'number' || !isNaN(Number(prop)) ? prop : (_target$prop = target === null || target === void 0 ? void 0 : target[prop]) !== null && _target$prop !== void 0 ? _target$prop : target === null || target === void 0 ? void 0 : target['small'];
  }
});
var alignItemsAgent = new Proxy(defaultAlignItems, {
  get: function get(target, prop) {
    var _target$prop2;
    return (_target$prop2 = target === null || target === void 0 ? void 0 : target[prop]) !== null && _target$prop2 !== void 0 ? _target$prop2 : target === null || target === void 0 ? void 0 : target['center'];
  }
});
export var Space = function Space(props) {
  var _ref2;
  var children = props.children,
    className = props.className,
    style = props.style,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'horizontal' : _props$direction,
    _props$size = props.size,
    size = _props$size === void 0 ? 'small' : _props$size,
    _props$align = props.align,
    align = _props$align === void 0 ? 'center' : _props$align;
  var classes = classNames(className, 'iron-space');
  var childrenList = Children.toArray(children);
  var spaceStyles = useMemo(function () {
    var returnStyle = direction === 'horizontal' ? alignItemsAgent[align] : {};
    if (direction === 'vertical') {
      returnStyle.flexDirection = 'column';
    } else {
      returnStyle.flexDirection = 'row';
    }
    return returnStyle;
  }, [direction, align]);
  if (Array.isArray(size)) {
    var _ref;
    console.log('size', size, (_ref = [].concat(_toConsumableArray(size), [''])) === null || _ref === void 0 ? void 0 : _ref.join('px'));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    style: _objectSpread(_objectSpread({}, spaceStyles), {}, {
      gap: Array.isArray(size) ? (_ref2 = [].concat(_toConsumableArray(size), [''])) === null || _ref2 === void 0 ? void 0 : _ref2.join('px ') : "".concat(sizeAgent[size], "px")
    }, style)
  }, childrenList === null || childrenList === void 0 ? void 0 : childrenList.map(function (child, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "iron-space-item"
    }, child);
  }));
};
export default /*#__PURE__*/memo(Space);